import { render, staticRenderFns } from "./MinutesView.vue?vue&type=template&id=0da371a4"
import script from "./MinutesView.vue?vue&type=script&lang=ts"
export * from "./MinutesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports